import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ICreateBrandAccounting } from "@shared/lib/types/accounting";
import { INVOICES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";

export function useCreateInvoice(
  handleSuccess: () => void,
  handleError: () => void
) {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreateBrandAccounting) =>
      AccountingService.createBrandAccounting(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        handleError();
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      handleSuccess();
      c.invalidateQueries({ queryKey: INVOICES_QUERY_KEY });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
